import { User } from '@/types';
import { LoadingStatus } from '@/types';

export enum GraphQLErrorClass {
  UNAUTHENTICATED = "App\\Exceptions\\Auth\\UnauthenticatedException",
  UNAUTHORIZED = "App\\Exceptions\\Auth\\UnauthorizedException", 
  NOT_FOUND = "App\\Exceptions\\NotFoundExceptionException",
  VALIDATION = "App\\Exceptions\\ValidationException",
  INVALID_CREDENTIALS = "App\\Exceptions\\Auth\\InvalidCredentialsException",
  AGE_VERIFICATION = "App\\Exceptions\\Auth\\AgeVerificationException",
  EMAIL_VERIFICATION = "App\\Exceptions\\Auth\\EmailVerificationException"
}

export interface AuthState {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
  status: LoadingStatus;
  error: string | null;
}

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface RegisterCredentials {
  name: string;
  email: string;
  password: string;
  confirmPassword: string;
  dateOfBirth: string;
} 